module.exports = __webpack_public_path__ + "static/media/Tornax-RT-3200.4fc0be2c.png";